<template>
    <div class="text-center py-3">
        <a href="./kup" title="Naslovna">
            <h2>Aplikacija KUP</h2>
        </a>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-2">
                    <div id="mySidenav" class="text-left">
                        <label class="ml-3">Sadržaj</label>
                        <div>
                            <ul class="nav nav-pills flex-column">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">1. Postavke</a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="scrollMeTo('section11')">1.1 Generalne
                                            postavke</a>
                                        <a class="dropdown-item" @click="scrollMeTo('section12')">1.2 Poslovne
                                            jedinice</a>
                                    </div>
                                </li>
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">2. Korisnici</a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="scrollMeTo('section21')">2.1 Novi korisnik</a>
                                        <a class="dropdown-item" @click="scrollMeTo('section22')">2.2 Pretraga
                                            korisnika</a>
                                        <a class="dropdown-item" @click="scrollMeTo('section23')">2.3 Kartica
                                            korisnika</a>
                                        <a class="dropdown-item" @click="scrollMeTo('section24')">2.4 Ispis kartica</a>
                                        <a class="dropdown-item" @click="scrollMeTo('section25')">2.5 Isčlanjenje
                                            korisnika</a>
                                    </div>
                                </li>
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">3. Pozajmice</a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="scrollMeTo('section31')">3.1 Nova pozajmica</a>
                                        <a class="dropdown-item" @click="scrollMeTo('section32')">3.2 Pretraga
                                            pozajmica</a>
                                        <a class="dropdown-item" @click="scrollMeTo('section33')">3.3 Otplata
                                            pozajmica</a>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" @click="scrollMeTo('section4')">4. Uplata uloga</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" @click="scrollMeTo('section5')">5. Ostali prihodi i rashodi</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" @click="scrollMeTo('section6')">6. Mjesečna isplata</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" @click="scrollMeTo('section7')">7. Obustave na plaći</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" @click="scrollMeTo('section8')">8. Temeljnica</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" @click="scrollMeTo('section9')">9. Financijske kartice</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" @click="scrollMeTo('section10')">10. Bilanca</a>
                                </li>
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">11. Dodatak</a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="scrollMeTo('section111')">11.1 Instalacija
                                            programa
                                            PrintKUP</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-10 text-justify">
                    <div class="pt-2">
                        <h2>Kasa uzajamne pomoći - <span class="small">Uputa</span></h2>
                        <hr>
                    </div>
                    <div ref="section11" class="section">
                        <h3>1. Postavke</h3>
                        <p>
                            Prije početka rada u aplikaciji potrebno je urediti postavke.<br />
                            Postavkama se pristupa kllikom na <strong>Postavke</strong> / <strong>Generalne
                                Postavke</strong> u desnom izborniku
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/postavke.png" />
                        <h3>1.1 Generalne postavke</h3>
                        <p>
                            U <strong>generalne postavke</strong> spremaju se konstantne vrijednosti koje koriste na
                            razini cijele aplikacije, a to su:
                        <ul>
                            <li>Valuta</li>
                            <li>Zadani mjesečni ulog</li>
                            <li>Manipulativni troškovi (koeficjent, za 2% koefcijent je 0.02)</li>
                            <li>Zadani rok otplate u mjesecima</li>
                            <li>Šifre <strong>konta</strong> za pojedinu vrestu prometa</li>
                            <li>Početno stanje žiro računa sa danom početka korištenja aplikacije</li>
                            <li>Početno stanje prihoda</li>
                            <li>Postavke ispisa</li>
                        </ul>
                        </p>
                    </div>
                    <div ref="section12" class="section">
                        <h3>1.2 Poslovne jedinice</h3>
                        <p>
                            Za dodavanje nove poslovne jedinice kliknuti na dugme <strong>Plus</strong>.<br />
                            Upisati <em>kod</em> (šifru) poslovne jedinice, naziv i kliknuti na <strong>Spremi</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/poslovnejedinice.png" />
                    </div>
                    <div ref="section22" class="section">
                        <h3>2.1 Novi korisnik</h3>
                        <p>Za dodavanje novog korisnika kase uzajamne pomoći u desnom izborniku kliknite na <strong>Novi
                                korisnik</strong>. Popunite sva polja i kliknite na tipku <strong>Spremi</strong>.</p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/novikorisnik1.png" />
                        <p>Za ispis pristupnice u PDF formatu kliknuti na <strong>Kreiraj PDF</strong>. Nakon što je PDF
                            kreiran kliknite na <strong>Preuzmi PDF</strong>.</p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/pristupnicaispis1.png" />
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/preuzmipdf.png" />
                        <div>
                            <em class="text-info">* Napomena: U Google Chrome-u PDF se preuzima kao na slici:</em>
                        </div>
                        <img class="img-responsive img-thumbnail img" src="../../assets/img/kup/tutorial/pdf.png" />
                    </div>
                    <div ref="section22" class="section">
                        <h3>2.2 Pretraga korisnika</h3>
                        <p>Za pretragu korisnika kliknite na <strong>Korisnici</strong>, zatim u polje
                            <strong>Pretraži...</strong> upišite ime ili prezime korisnika kojeg tražite i kliknite na
                            ikonicu za pretragu ili tipku <strong>Enter</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/korisnici1.png" />
                        <p>Korisničkim podacima i kartici korisnika pristupate klikom na ikone označene na slici.</p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/korisnici2.png" />
                    </div>
                    <div ref="section23" class="section">
                        <h3>2.3 Kartica korisnika</h3>
                        <p>
                            Kartici korisnika se pristupa klikom na <strong>Kartica korisnika</strong> ili preko
                            pretrage korisnika (vidi točku 1.2)<br />
                            Odabrati korisnika iz padajučeg izbornika, godinu i kliknuti na ikonu
                            <strong>Filter</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/karticakorisnika1.png" />
                    </div>
                    <div ref="section24" class="section">
                        <h3>2.4 Ispis kartica</h3>
                        <p>Za ispis kartice korisnika kliknuti na dugme <strong>PDF</strong>. Nakon što se pojavi
                            <strong>Preuzmi PDF</strong>, kliknuti desni klik i stisnuti <strong>Save target
                                as</strong>.
                            Datoteku spremiti na lokalni disk.
                        </p>
                        <p>Za ispis svih korisnika istovremeno, odabrati poslovnu jedinicu, godinu i kliknuti na
                            <strong>Spremi sve kartice u ZIP</strong>.
                            Nakon što se kreira PDF, stisnuti desni klik na datoteku i kliknuti na <strong>Save target
                                as</strong>.
                        </p>
                        <div>
                            <em class="text-danger">* Napomena: Kreiraju se samo kartice aktivnih korisnika.</em>
                        </div>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/karticekorisnikazip1.png" />
                        <p>Odabrati lokaciju na računalu i stisnuti <strong>Save</strong>.</p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/karticekorisnikazip2.png" />
                        <p>Otvoriti lokaciju na kojoj je spremljena ZIP datoteka, desni klik na datoteku i kliknuti na
                            <strong>Extract Here</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/karticekorisnikazip3.png" />
                        <p>Otvoriti sve foldere unutar <strong>root</strong> direktorija dok se ne dođe do
                            <strong>PDF</strong> datoteka.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/karticekorisnikazip4.png" />
                        <h3>2.4.1 Ispis (Metoda 1.)</h3>
                        <p>Za ispis svih kartica na printeru, označiti sve datoteke (<strong>Ctrl+A</strong>), desni
                            klik na mišu i kliknuti na <strong>Print</strong>.</p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/karticekorisnikazip5.png" />
                        <h3>2.4.2 Ispis (Metoda 2.)</h3>
                        <div>
                            <p>
                                Kartice je moguće isprintati pomoću programa <strong>PrintKUP</strong>.
                                Klikom na dugme <strong>Pretraži</strong> odaberemo putanju (<em>folder</em>) u kojemu
                                se nalaze pozajmice (<em>PDF datoteke</em>). Poželjno je
                                ne stavljati sve pozajmice u jedan folder već ih odvajati npr. prema poslovnim
                                jedinicama.
                                Nakon što se klikne na dugme <strong>ISPIS</strong>, kartice se automatski šalju na
                                printer jedna po jedna u razmaku od 10 sekundi.
                                Razmak između ispisa se može smanjiti ili povećati u <strong>Postavkama</strong>.
                            </p>
                            <div>
                                <img class="img-responsive img-thumbnail img"
                                    src="../../assets/img/kup/tutorial/printkup1.png" />
                            </div>
                            <p>
                                Za rad aplikacije je potrebno imati instaliran <strong>Acrobat Reader</strong>.
                                U postavkama mora biti definirana putanja od <strong>AcroRd32.exe</strong>.
                            </p>
                            <div>
                                <img class="img-responsive img-thumbnail img"
                                    src="../../assets/img/kup/tutorial/printkup2.png" />
                            </div>
                            <em class="text-danger">
                                * Napomena: Uputa za instalaciju se nalazi u <strong>Dodatku</strong> (<a
                                    @click="scrollMeTo('section111')" title="Uputa za instalaciju PrintKUP">točka:
                                    11.1</a>).
                            </em>
                            <!--<em class="text-danger">
                            * Napomena: Prije ispisa u <strong>Generalnim postavkama</strong> potrebno je upisati i spremiti lokaciju
                            na u kojoj je instaliran <strong>Acrobat Reader</strong> (<em>Lokacija gdje se nalazi <strong>AcroRd32.exe</strong></em>) .<br />
                        </em>-->
                            <!--<img class="img-responsive img-thumbnail img" src="../../assets/img/kup/tutorial/acrobatreaderpath.png" />-->
                        </div>
                    </div>
                    <div ref="section25" class="section">
                        <h3>2.5 Isčlanjenje korisnika</h3>
                        <p>Za isčlanjenje korisnika potrebno je otvoriti korisnički profil korisnika (vidi točku 1.2).
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/isclanjenje1.png" />
                        <p>Pod <strong>status korinsnika</strong> odabrati <em>Neaktivan</em>, odabrati datum
                            isčlanjenja i kliknuti <strong>Spremi</strong>.</p>
                        <div>
                            <em class="text-danger">
                                * Napomena: Ako je dug veći od ukupno utplaćenog uloga i rata pozajmica, korisnik se ne
                                može isčlaniti.<br />
                                Ako se korisnik želi isčlaniti, a nije podmirio dug, onda se preostali dug automatski
                                oduzima od uloga, a korisniku se isplaćuje ostatak.
                            </em>
                        </div>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/isclanjenje2.png" />
                    </div>
                    <div ref="section31" class="section">
                        <h3>3.1 Nova pozajmica</h3>
                        <p>
                            U desnom izborniku kliknuti na <strong>Nova Pozajmica</strong>.<br />
                            Odabrati korisnika, upisati iznos pozajmice i rok otplate u mjesecima ili iznos mjesečne
                            rate za otplatu i kliknuti <strong>Spremi</strong>.<br />
                            Za ispis kliknuti na <strong>PDF</strong>.
                        </p>
                        <div>
                            <em class="text-danger">* Napomena: Iznos za isplatu se umanjuje za iznos manipulativnog
                                troška i starog duga.</em>
                        </div>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/novapozajmica.png" />
                        <h3>3.2.1 Otplata starog duga</h3>
                        <p>
                            Ako korisnik otvara novu pozajmicu, a stara pozajmica još nije otplaćena, program automatski
                            zatvara staru pozajmicu dijelom nove pozajmice, a ostatak se isplaćuje korisniku.
                            Moguće je i ručno upisati iznos za otplatu stare pozajmice, npr. u slučaju pogrešno
                            isplaćenog iznosa korisniku.
                            Ovaj iznos ne smije biti veći od iznosa starog duga.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/otplatastarogduga.png" />
                    </div>
                    <div ref="section32" class="section">
                        <h3>3.2 Pretraga pozajmica</h3>
                        <p>
                            Za pretragu pozajmica kliknuti na <strong>Pozajmice</strong> u desnom izborniku.<br />
                            Pretraživati se može po poslovnoj jedinici, mjesecu i godini ili po imenu i prezimenu
                            korisnika pozajmice.<br />
                            Za prikaz više detalja o pozajmici kliknuti na dugme označeno na slici.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/pozajmice.png" />
                    </div>
                    <div ref="section33" class="section">
                        <h3>3.3 Otplata pozajmice</h3>
                        <p>
                            U desnom izborniku kliknuti na <strong>Otplata Pozajmice</strong>.<br />
                            Odabrati poslovnu jedinicu, mjesec godinu i kliknuti na dugme <strong>Filter</strong>.<br />
                            Za odabranog korisnika kliknuti na strelicu u koloni <strong>Ugovorena rata</strong> ili
                            ručno upisati željeni iznos u polje u koloni <strong>Uplaćeno</strong>
                            i kliknuti na tipku <strong>Spremi</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/otplatapozajmice1.png" />
                        <p>
                            U slučaju kada korisnik sam uplaćuje ratu pozajmice na žiro račun KUP-a (npr. u slučaju kada
                            korisnik ima zaštićeni račun pa mu se ne može izvršit obustava na plaći
                            ili u slučaju povrata pogrešno uplaćene pozajmice na račun korisnika),
                            treba kliknuti na dugme <strong>Uplata korisnika</strong>
                            nakon čega se otvara novo polje za unos. Upisati datum i iznos i kliknuti na dugme
                            <strong>Spremi</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/otplatapozajmice2.png" />
                    </div>
                    <div ref="section4" class="section">
                        <h3>4. Uplata uloga</h3>
                        <p>
                            U desnom izborniku kliknuti na <strong>Uplata Uloga</strong>.<br />
                            Odabrati poslovnu jedinicu, mjesec godinu i kliknuti na dugme <strong>Filter</strong>.<br />
                            Za odabranog korisnika kliknuti na strelicu u koloni <strong>Ugovoreni ulog</strong> ili
                            ručno upisati željeni iznos u polje u koloni <strong>Uplaćeno</strong>
                            i kliknuti na tipku <strong>Spremi</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/uplatauloga1.png" />
                        <p>
                            U slučaju kada korisnik sam uplaćuje ulog na žiro račun KUP-a (npr. u slučaju kada korisnik
                            ima zaštićeni račun pa mu se ne može izvršit obustava na plaći),
                            treba kliknuti na dugme <strong>Uplata korisnika</strong>
                            nakon čega se otvara novo polje za unos. Upisati datum i iznos i kliknuti na dugme
                            <strong>Spremi</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/uplatauloga2.png" />
                    </div>
                    <div ref="section5" class="section">
                        <h3>5. Ostali prihodi i rashodi</h3>
                        <p>
                            Pod ostale prihode i rashode spadaju <strong>troškovi održavanja računa, kamate po štednji i
                                ostali troškovi</strong>.<br />
                            Iz desnog izbornika odabrati vrstu troška, selektirati godinu i kliknuti na
                            <strong>Filter</strong>.<br />
                            Kliknuti na dugme <strong>Novi Unos</strong>, odabrati datum, upisati iznos i opis i
                            kliknuti na dugme <strong>Spremi</strong>.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/ostaliprihodiirashodi1.png" />
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/ostaliprihodiirashodi2.png" />
                    </div>
                    <div ref="section6" class="section">
                        <h3>6. Mjesečna isplata</h3>
                        <p>
                            Za prikaz svih mjesečnih isplata sa žiro računa kliknuti na <strong>Mjesečna
                                isplata</strong>.<br />
                            Odabrati mjesec i godinu i kliknuti na <strong>Filter</strong>.<br />
                            U tablici su prikazne sve isplate u tekućem mjesecu (isplate pozajmica, isplate kod
                            iščćanjenja, troškovi održavanja računa i razni materijalni troškovi).
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/mjesecnaisplata.png" />
                    </div>
                    <div ref="section7" class="section">
                        <h3>7. Obustave na plaći</h3>
                        <p>
                            Za prikaz obustava na plaći kliknuti na <strong>Obustave Na Plaći</strong>.<br />
                            Odabrati poslovnu jedinicu mjesec i godinu i kliknuti na <strong>Filter</strong>.<br />
                            Moguć je prikaz ukupnih obustava (ulog + pozajmice) ili po poslovnim jedinicama.<br />
                        </p>
                        <div>
                            <em class="text-danger">* Napomena:
                                Zvjezdicom su označene samo promjene u odnosu na prethodni mjesec. Ako želite prikazati
                                samo te promjene onda treba kliknuti na <em>Check box</em>: <strong>Prikaži samo
                                    promjene u odnosu na prethodni mjesec</strong>.
                            </em>
                        </div>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/obustavenaplaci.png" />
                    </div>
                    <div ref="section8" class="section">
                        <h3>8. Temeljnica</h3>
                        <p>
                            Za prikaz temeljnice kliknuti na <strong>Temeljnica</strong>.<br />
                            Odabrati mjesec i godinu i kliknuti na <strong>Filter</strong>.<br />
                            U tablici su prikazne sve isplate u tekućem mjesecu (isplate pozajmica, isplate kod
                            iščćanjenja, troškovi održavanja računa i razni materijalni troškovi).
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/temeljnica.png" />
                    </div>
                    <div ref="section9" class="section">
                        <h3>9. Financijske kartice</h3>
                        <p>
                            Za prikaz Financijskih kartica kliknuti na <strong>Financijske Kartice</strong>.<br />
                            Odabrati godinu i kliknuti na <strong>Filter</strong>.<br />
                            Program daje ispis ukupnog prometa (mjesečno i kumulativno) za odabranu godinu i to za
                            promet uloga, pozajmica, manipulativnih troškova, troškova održavanja računa,
                            kamata po štednji i raznih materijalnih troškova.
                        </p>
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/financijskekartice.png" />
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/financijskekarticeulozi.png" />
                    </div>
                    <div ref="section10" class="section">
                        <h3>10. Bilanca</h3>
                        <p>
                            Za pregled bilance kliknuti na <strong>Bilanca</strong>.<br />
                            Odabrati godinu i kliknuti na <strong>Filter</strong>.<br />
                            U tablicama su dani podaci o ukupnim prihodima, rashodima i razlici rashoda i prihoda za
                            odabranu godinu, kao i temeljnica.
                        </p>
                        <img class="img-responsive img-thumbnail img" src="../../assets/img/kup/tutorial/bilanca.png" />
                        <img class="img-responsive img-thumbnail img"
                            src="../../assets/img/kup/tutorial/bilancaprihodi.png" />
                    </div>
                    <div ref="section110" class="section">
                        <h3>11 Dodatak </h3>
                    </div>
                    <div ref="section111" class="section">
                        <h3>11.1 Instalacija programa <strong>PrintKUP</strong> </h3>
                        Zip datoteku <strong>PrintKUP.zip</strong> možete pruzeti <a href="/files/kup/PrintKUP.zip"
                            download title="PrintKUP.zip">ovdje</a>.
                        <p class="pt-3">Postupak preuzimanja:</p>
                        <p>1. Google Chrome:</p>
                        <div>
                            <img class="img-responsive img-thumbnail img"
                                src="../../assets/img/kup/tutorial/printkupdownload1.png" />
                        </div>
                        <p>2. Microsoft Edge:</p>
                        <div>
                            <img class="img-responsive img-thumbnail img"
                                src="../../assets/img/kup/tutorial/downloadprintkupme1.png" />
                        </div>
                        <div>
                            <img class="img-responsive img-thumbnail img"
                                src="../../assets/img/kup/tutorial/downloadprintkupme2.png" />
                        </div>
                        <p>Otvorite datoteku <strong>PrintKUP.zip</strong>, zatim dvostrukim klikom pokrenite
                            <strong>setup.exe</strong>.
                        </p>
                        <div>
                            <img class="img-responsive img-thumbnail img"
                                src="../../assets/img/kup/tutorial/printkupinstall3.png" />
                        </div>
                        <p>Kliknite na tipku <strong>Install</strong>.</p>
                        <div>
                            <img class="img-responsive img-thumbnail img"
                                src="../../assets/img/kup/tutorial/printkupinstall1.png" />
                        </div>
                        <div>
                            <em class="text-danger">
                                * Napomena: Za rad programa potrebno je imati instaliran <strong>Microsoft .NET
                                    Framework 4.0</strong>. Program će sam detektirati dali je Framework instaliran.
                                Ako nije ponudit će vam opciju da ga instlairate.
                            </em>
                        </div>
                        <p class="mt-3">Za pokretanje programa kliknuti na <strong>Search</strong> i upisati
                            <em>printkup</em>.
                        </p>
                        <div>
                            <img class="img-responsive img-thumbnail img"
                                src="../../assets/img/kup/tutorial/printkupinstall2.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        titleTemplate: "%s | KUP - Uputa",
        meta: [
            {
                name: "description",
                content: "KUP - Kasa uzajamne pomoće - uputa",
            },
        ],
    },
    mounted() {
        console.log('process.env', process.env)
    },
    methods: {
        scrollMeTo(refName) {
            var element = this.$refs[refName];
            var top = element.offsetTop;
            window.scrollTo(0, top);
        },
        openNav() {
            document.getElementById("mySidenav").style.width = "270px";
        },
        closeNav() {
            document.getElementById("mySidenav").style.width = "0";
        },
    },
};
</script>

<style scoped>
body {
    font-family: "Encode Sans Expanded";
    font-size: 16px;
    position: relative;
}

/* ul.nav-pills {
  top: 80px;
  position: fixed;
} */
.section {
    padding-top: 30px;
}

.img {
    margin: 10px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/kup/tutorial.vue